var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"py-12 px-5 fill-height"},[_c('v-col',{staticClass:"py-12 fill-height text-center",attrs:{"cols":"12"}},[_c('h1',[_vm._v("404")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }